<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right" style="display: none;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>出库维护</el-breadcrumb-item>
            <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="body02">
            <div class="body02-1">
                <el-card class="card_gundong">
                    <!-- 124{{ guest_level_parent }} -->
                    <el-row :gutter="0">
                        <el-col :span="10">
                            <productTypeSelect style="width: 240px;"
                                @getProductTypeSelectedUid="getProductTypeSelectedUid" ref="productTypeSelect"
                                :chanpin_type="productTypeSelect" :key="this.datekey">
                            </productTypeSelect>
                        </el-col>
                        <el-col :span="2">
                        </el-col>
                        <el-col :span="10">
                            <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select"
                                clearable style="width:300px " @clear="getproductList" @change="getproductList">
                                <el-button slot="append" icon="el-icon-search" @click="getproductList"></el-button>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <!-- ---------- -->
                        <el-col :span="24">
                            <el-table :data="productList" style="width: 100%" border stripe>
                                <el-table-column type="expand">
                                    <template slot-scope="scope" v-if="scope.row.proType04Code === 9005">
                                        <el-table :data="scope.row.zuheProductlist" stripe>
                                            <el-table-column type="index" label="序号" width="80"></el-table-column>
                                            <el-table-column prop="pro_uid" label="商品序号" width="200"> </el-table-column>
                                            <el-table-column prop="pro_name" label="商品名称" width="200">
                                            </el-table-column>
                                            <el-table-column label="商品类别" width="300">
                                                <template slot-scope="scope">{{ scope.row.leixing01 }}:{{
                scope.row.leixing02 }}:{{ scope.row.leixing03 }}:{{
                scope.row.leixing04 }}</template>
                                            </el-table-column>
                                            <el-table-column prop="pro_count" label="商品数量"
                                                show-overflow-tooltip></el-table-column>
                                            <el-table-column prop="pro_count_kucun" label="库存数量" show-overflow-tooltip>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
                                <!-- <el-table-column prop="uid" label="序号" width="60"></el-table-column> -->

                                <el-table-column prop="pro_bianhao" label=" 编号" width="150"></el-table-column>
                                <el-table-column prop="pro_name" label="名称"></el-table-column>
                                <!-- <el-table-column label="类型">
                                    <template v-slot="scope">
                                        {{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{ scope.row.leixing03 }}:{{
                                            scope.row.leixing04 }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="库存数量">
                                    <template slot-scope="scope3">
                                        {{ scope3.row.kucun_pro_count - scope3.row.kucun_pro_count_suoding }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column prop="kucun_qiye_uid" label="kucun_qiye_uid"></el-table-column> -->
                                <!-- <el-table-column prop="pro_xinghao" label="型号"></el-table-column> -->
                                <!-- <el-table-column prop="pro_chandi" label="产地"></el-table-column> -->
                                <!-- <el-table-column prop="add_time" label="加入时间" c></el-table-column> -->
                                <el-table-column prop="pro_price_shichang" label="市场价" v-if="guest_level_parent === 0">
                                </el-table-column>
                                <el-table-column prop="pro_price_huiyuan" label="会员价" v-if="guest_level_parent === 1">
                                </el-table-column>
                                <el-table-column prop="pro_price_pifa" label="批发价" v-if="false"> </el-table-column>
                                <el-table-column prop="pro_price_gaoji" label="高级会员价" v-if="guest_level_parent === 2">
                                </el-table-column>
                                <el-table-column label="操作" width="300px">
                                    <template v-slot="scope">
                                        <el-input-number v-model="scope.row.count" :min="1" :max="100000"
                                            style="width: 140px;" label="描述文字"></el-input-number>
                                        <el-button @click="kucun_chuku_add(scope.$index, scope.row.kucun_uid, scope.row.uid, scope.row.pro_bianhao, scope.row.pro_name, scope.row.pro_type, scope.row.leixing01, scope.row.leixing02, scope.row.leixing03, scope.row.leixing04, scope.row.count, scope.row.proType04Code, scope.row.zuheProductlist,
                guest_level_parent === 0 ? scope.row.pro_price_shichang
                    : guest_level_parent === 1 ? scope.row.pro_price_huiyuan
                        : scope.row.pro_price_gaoji)" type="primary" plain
                                            style="margin-left: 10px;">添加</el-button>
                                        <!-- 读出数量，在添加的时候，就要做数量上的判断 -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-card>
                <!-- 分页 -->
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                    <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
                </el-pagination>
            </div>
            <div class="body02-2">
                <el-card class="card_gundong002">

                    <el-card style="background-color: #dee;">

                        <span style="background-color: #ddd;width: 100%;padding: 0px;"> 出库单编号：{{ chukudan_bianhao }}
                        </span>
                        <el-table ref="multipleTable" :data="kucunAddData" tooltip-effect="dark" style="width: 100%"
                            @selection-change="handleSelectionChange"
                            :default-sort="{ prop: 'xuhao', order: 'descending' }">

                            <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index
                                    }}</template>
                            </el-table-column>
                            <!-- <el-table-column prop="proUid" label="商品序号"> </el-table-column> -->
                            <el-table-column prop="proName" label="商品名称"> </el-table-column>
                            <el-table-column label="商品类别">
                                <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                            </el-table-column>
                            <el-table-column prop="proPrice" label="价格">
                                <template v-slot="scope">
                                    <el-input v-model="scope.row.proPrice" style="width: 100px;" label="价格"
                                        @input="sum_order_money"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="proCount" label="商品数量" show-overflow-tooltip>

                            </el-table-column>
                            <el-table-column label="操作" show-overflow-tooltip>
                                <template slot-scope="scope2">
                                    <el-button @click="chuku_delete(scope2.$index, kucunAddData)"
                                        style="font-size: 22px;" v-if="scope2.row.delFlag === 1" type="text"
                                        icon="el-icon-remove-outline"></el-button>
                                </template>

                            </el-table-column>

                        </el-table>
                    </el-card>
                    <!-- v-if="kaidanFlag === 1" -->
                    <div style="text-align: right;font-size:25px;font-weight: 400;" >
                        备注：<el-input v-model="orderMemo" style="width: 300px;" label=""
                            @input="sum_order_money"></el-input> 订单总额合计： <span style="color: red;">{{ order_money
                            }}</span> 元
                    </div>
                    <div style="margin-top: 20px;text-align: center;">
                        <el-button type="primary" @click="product_chuku"
                            v-if="kaidanFlag !== 1 && caozuo_type !== '1'">确定出库</el-button>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>
<script>
import productTypeSelect from '../../tongyong/productType_select.vue'
import { checkMobileTest, checkSfzId } from '../config/validator';
export default {
    props: ['dataParent', 'diaoyongType', 'caozuo_type', 'mendianUid', 'productTypeSelect'],
    //  caozuo_type 操作类型 1  直接操作  2 调用操作 productTypeSelect 类型选择参数  
    components: {
        productTypeSelect: productTypeSelect
    },
    data() {
        return {
            orderMemo: '',
            guest_level_parent: 0,
            datekey: Date.now(),
            order_bianhao: '',
            kaidanFlag: 0,
            chukudan_bianhao: '',
            kucunAddData: [],
            kucunAddData_kucunUid: [],
            order_money: 0,
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list_more',
                C_table_name: 'product_list04', // 04 为读取有库存的所有商品
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.mendianUid,
                CI_canshu03: 2
            },
            productList: [],
            //  recordCount: 0,
            total: 0,
            // 表单规则项
            addFormRules: {
                pro_name: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ]
            },

            editFormRules: {

            }
        };
    },
    created() {
        this.getproductList()
        this.chukudan_bianhao_get()
        if (this.caozuo_type === '1') return // 说明仅仅是出库操作，无需执行下面的程序
        // console.log('dataParent', this.dataParent)
        this.guest_level_parent = this.dataParent.guest_info.guest_level
        this.order_bianhao = this.dataParent.order_bianhao
        this.kaidanFlag = this.dataParent.kaidanFlag
        //  console.log(900, this.guest_level)
        // this.guest_level_parent = this.guest_level
    },
    methods: {
        getProductTypeSelectedUid(val) {
            // this.data.proTypeUid = val.productTypeSelectedUid
            this.proTypeUid = val.productTypeSelectedUid
            this.queryInfo.CI_canshu02 = this.proTypeUid

            this.getproductList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //  进行产品添加
        async kucun_chuku_add(index, kucunUid, proUid, proBianhao, proName, proType, leixing01, leixing02, leixing03, leixing04, proCount, proType04Code, zuheProductlist, proPrice) {
            // 分析商品uid 重复的 直接累加
            // 借助 kucunAddData_kucunUid 找到下标
            //  console.log(101, proPrice)
            // 库存锁定数量，一般商品出库，要扣除礼包数量，也就是说防止单独销售礼包的附赠商品
            // await this.getproductList()
            // console.log('kucun', index, this.productList[index].kucun_pro_count, this.productList[index].kucun_pro_count_suoding)
            if (this.productList[index].kucun_pro_count - this.productList[index].kucun_pro_count_suoding < proCount) {
                this.$message.error('库存数量不足,出库失败');
                return;
            } else this.productList[index].kucun_pro_count_suoding = this.productList[index].kucun_pro_count_suoding + proCount
            // 下标识别一定要用kucun_uid，以便后期处理库存
            const xiabiao = this.kucunAddData_kucunUid.indexOf(kucunUid) // 找到下标返回下标，没有找到返回-1
            if (xiabiao !== -1) {
                this.kucunAddData[xiabiao].proCount += proCount
                // 处理附赠商品的数据，也要同时增加数量
                if (proType04Code === 9005) {
                    const obj = zuheProductlist
                    console.log('obj', obj)
                    obj.forEach((item, index) => {
                        var xiabiao2 = this.kucunAddData_kucunUid.indexOf(item.uid)
                        console.log('xiabiao2', this.kucunAddData_proUid, xiabiao2, item.uid)
                        if (xiabiao2 !== -1) {
                            this.kucunAddData[xiabiao2].proCount += proCount * item.pro_count
                        }
                        // 不能删除
                    })
                }
                this.sum_order_money()
                return
            }
            // 
            var dataAdd = {
                proUid: proUid,
                proBianhao: proBianhao,
                proName: proName,
                proType: proType,
                leixing01: leixing01,
                leixing02: leixing02,
                leixing03: leixing03,
                leixing04: leixing04,
                proCount: proCount,
                proPrice: proPrice,
                kucun_uid: kucunUid,
                proType04Code: proType04Code,
                delFlag: 1, // 列表框是否可以删除标记，只有 主商品可以删除，主商品删除，附赠商品一起删除
                zuheProductlist: zuheProductlist // 压入数组，方便删除时候用
            }
            // console.log(999, dataAdd)
            //  读出数量，在添加的时候，就要做数量上的判断 要限制，否则乱套，库存及价格无法计算和核算
            // 大礼包商品只能做单次出库
            var queryData = {
                C_type: 'product_kucunCountScan',
                proUid: proUid,
                proCount: proCount,
                mendianUid: this.mendianUid
            }

            const { data: res } = await this.$http.post('api', queryData)
            // console.log(112, JSON.parse(res.data)[0].status)

            if (JSON.parse(res.data)[0].status === 201) {
                this.$message.error('库存数量不足,出库失败');// 更新数据库之前做判断
                // 一般商品出库，要扣除礼包数量，也就是说防止单独销售礼包的附赠商
                // 礼包出库，一定要保证有商品，一般商品可以直接附赠，但是礼包的附赠商品不能单独做为商品销售
                return;
            }
            if (JSON.parse(res.data)[0].status === 202) {
                this.$message.error('组合商品包含商品有库存数量不足情况，出库失败');// 更新数据库之前做判断
                // 一般商品出库，要扣除礼包数量，也就是说防止单独销售礼包的附赠商
                // 礼包出库，一定要保证有商品，一般商品可以直接附赠，但是礼包的附赠商品不能单独做为商品销售
                return;
            }
            // 正常 则增加锁定数量

            // console.log(dataAdd)
            this.kucunAddData.push(dataAdd)
            this.kucunAddData_kucunUid.push(kucunUid)
            if (proType04Code === 9005) {
                const obj = zuheProductlist
                obj.forEach((item, index) => {
                    // console.log(item)
                    dataAdd = {
                        proUid: item.uid,
                        proBianhao: item.proBianhao,
                        proName: item.pro_name,
                        proType: item.proType,
                        leixing01: item.leixing01,
                        leixing02: item.leixing02,
                        leixing03: item.leixing03,
                        leixing04: item.leixing04,
                        proCount: proCount * item.pro_count, // 数量大基数要乘以组合的单品数量
                        proPrice: 0.0,
                        kucun_uid: item.kucun_uid,
                        proTypeCode: item.proTypeCode, // proTypeCode 用来标识类别是否是组合商品，添加商品时可以进行处理 ,不用proType 这个是防止，数据重新导入的时候，该uid会变化
                        delFlag: 0
                    }
                    this.kucunAddData.push(dataAdd)
                    this.kucunAddData_kucunUid.push(item.uid)
                })
            }
            console.log(998, this.kucunAddData)
            this.sum_order_money()
        },
        chuku_count_input() {

        },
        sum_order_money() {
            var sum = 0
            const obj = this.kucunAddData
            console.log(9090, obj)
            obj.forEach((item, index) => {
                // console.log(item)
                sum += item.proPrice * item.proCount
            })
            this.order_money = sum
        },
        async chukudan_bianhao_get(proUid, proCount) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 18 }
            })
            this.chukudan_bianhao = JSON.parse(res.data)[0].bianhao_l
        },
        async getproductList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            console.log(1110, JSON.parse(res.data)[0].dataList)
            this.productList = JSON.parse(res.data)[0].dataList
            if (!this.productList) return;
            this.productList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });
            this.total = JSON.parse(res.data)[0].total;
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getproductList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getproductList();
        },
        async product_chuku(callback) {
            var errFlag = await this.test_input()
            // console.log('errflag', errFlag)
            if (errFlag === 1) {
                if (this.kaidanFlag === 1) callback(errFlag)
                // else this.addDialogVisible = false 
                return
            }
            var chukuData = {
                C_type: 'kucun_chukudan_add',
                count: this.kucunAddData.length,
                chukudan_bianhao: this.chukudan_bianhao,
                chuku_type: this.kaidanFlag,
                order_money: this.order_money,
                chuku_pro_list: [],
                mendianUid: this.mendianUid,
                chuku_demo: this.orderMemo
            }

            const { data: res } = await this.$http.post('api', chukuData)
            if (JSON.parse(res.data)[0].status === 201) {
                this.$message.error('库存数量不足，出库失败');
                return;
            }
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('出库失败');
                return;
            }
            // 针对批次不一样的，需要弹窗做出选择，然后进行扣除
            var chukudanUid = JSON.parse(res.data)[0].chukudan_uid
            const obj = this.kucunAddData
            console.log(obj)
            obj.forEach((item, index) => {
                console.log(9999, item)
                const data = {
                    C_type: 'kucun_chuku_add',
                    pro_uid: item.proUid,
                    pro_count: item.proCount,
                    chukudan_uid: chukudanUid,
                    mendianUid: this.mendianUid,
                    pro_price: 0, // 公司出库，单价为0，直接出库
                    kucun_uid: item.kucun_uid // 出库至关重要 ，用来标识仓库uid
                }
                const { data: res02 } = this.$http.post('api', data);
            })
            this.$message.success('出库成功');
            this.getproductList()
            this.input_init()
            if (this.kaidanFlag === 1) callback(chukudanUid)
            if (this.kaidanFlag === 0) this.$emit('closeAdd', '');
        },
        async product_kaidan(callback) {
            var kaidanData = {
                C_type: 'order_add',
                count: this.kucunAddData.length,
                chukudan_bianhao: this.chukudan_bianhao,
                chuku_type: this.kaidanFlag,
                order_money: this.order_money,
                order_money_dikou: 0,
                order_money_shengyu: this.order_money,
                order_bianhao: this.order_bianhao,
                order_memo: this.orderMemo,
                chuku_pro_list: []
                // 在此不计算 抵扣金额，和剩余金额，要在结算的时候，选择结算类型，然后进行结算
            }
            var errFlag = await this.test_input()
            if (errFlag === 1) {
                callback(errFlag, kaidanData)
                return
            }

            const obj = this.kucunAddData
            console.log(999, obj)
            obj.forEach((item, index) => {
                // 因为此处是销售开单，所需要的商品数量和价格 都是经过筛选的，需要重新写一次开单数组，并callback 回主函数
                // 要返回开单的订单json递交数据库的  
                const data = {
                    C_type: 'order_mingxi_add',
                    pro_uid: item.proUid,
                    pro_count: item.proCount,
                    chukudan_bianhao: this.chukudan_bianhao,
                    chexing01: item.leixing01,
                    chexing02: item.leixing02,
                    chexing03: item.leixing03,
                    chexing04: item.leixing04,
                    pro_name: item.proName,
                    pro_price: item.proPrice,
                    pro_code: item.proCode,
                    kucun_uid: item.kucun_uid
                }
                kaidanData.chuku_pro_list.push(data)
                callback(errFlag, kaidanData)
            })
        },
        async test_input() {
            if (this.kucunAddData.length === 0) {
                this.$message.error('请录入商品及数量后再行递交！')
                return 1
            }
            const comfirmResult = await this.$confirm(
                '确定商品出库, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            if (comfirmResult === 'cancel') return 1
            else return 0
        },
        input_init() {
            this.getproductList()
            this.kucunAddData = []
            this.kucunAddData_kucunUid = []
            this.chukudan_bianhao_get()
        },
        async productInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'product_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.editForm = JSON.parse(res.data)[0].data[0];
            console.log(700, this.editForm)
        },
        async chuku_delete(index, rows) {
            console.log(803, index, rows)
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(804, comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');

            // 取消库存锁定的对应数量
            var suodingQuxiao = {
                C_type: 'kucun_suodingCount_quxiao',
                proCount: rows[index].proCount,
                proUid: rows[index].proUid,
                mendianUid: this.mendianUid
            }
            console.log('suodingQuxiao', rows, suodingQuxiao)
            await this.$http.post('api', suodingQuxiao)
            await this.getproductList()
            //  先删除所有组合商品的单品，然后再删除组合商品
            if (rows[index].proType04Code === 9005) {
                const obj = rows[index].zuheProductlist
                console.log('obj2', obj)
                obj.forEach((item, index) => {
                    var xiabiao2 = this.kucunAddData_kucunUid.indexOf(item.uid)
                    console.log('xiabiao2', this.kucunAddData_proUid, xiabiao2, item.uid)
                    if (xiabiao2 !== -1) {
                        rows.splice(xiabiao2, 1)
                        this.kucunAddData_kucunUid.splice(xiabiao2, 1)
                        // this.kucunAddData[xiabiao2].proCount += proCount * item.pro_count
                    }
                    // 不能删除
                })
            }
            this.sum_order_money()
            rows.splice(index, 1)
            // 恢复库存的锁定数量
            // 找到库存项
            this.kucunAddData_kucunUid.splice(index, 1)
            this.sum_order_money()
        }
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}

.card_gundong {
    height: 500px;
    overflow-y: auto;
}

.card_gundong002 {
    height: 500px;
    overflow-y: auto;
}

.body02 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.body02-1 {
    width: 50%;
}

.body02-2 {
    width: 50%;
}
</style>
